import React from 'react';
// import { FaBadmintonBirdie, FaCricket, FaDumbbell } from 'react-icons/fa';
import pricingData from '../config/pricing.json';

export default function Pricing() {
  const getIcon = (sport) => {
    switch (sport) {
      //   case 'Badminton':
      //     return <FaBadmintonBirdie />;
      //   case 'Box Cricket':
      //     return <FaCricket />;
      //   case 'Gym':
      //     return <FaDumbbell />;
      default:
        return null;
    }
  };

  const getBorderColor = (index) => {
    const colors = ['#ff6b35', '#004e89', '#f7b801'];
    return colors[index % 3];
  };

  return (
    <section id="pricing" className="section">
      <h2 className="section-title">Pricing & Membership</h2>
      <p className="section-subtitle">Flexible plans to suit your needs. Edit prices in src/config/pricing.json</p>

      <div className="pricing-grid">
        {pricingData.pricing.map((item, index) => (
          <div key={item.id} className="pricing-card" style={{ borderLeftColor: getBorderColor(index) }}>
            <h3>
              {getIcon(item.sport)}
              {' '}{item.sport}
            </h3>
            <p>{item.description}</p>

            <ul className="rate-list">
              {item.rates.map((rate, rateIndex) => (
                <li key={rateIndex} className="rate-item">
                  <div className="rate-type">{rate.type}</div>
                  <div className="rate-price">{rate.price}</div>
                  <div className="rate-duration">{rate.duration}</div>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div style={{
        background: '#f0f8ff',
        border: '2px solid #004e89',
        padding: '1.5rem',
        borderRadius: '8px',
        marginTop: '2rem',
        textAlign: 'center'
      }}>
        <h4 style={{ color: '#004e89', marginBottom: '0.5rem' }}>💝 Special Offer</h4>
        <p style={{ color: '#333' }}>
          Take our <strong>Couple Membership</strong> for <strong>attractive discounts</strong>
        </p>
      </div>
    </section>
  );
}
